import React from 'react';
import { IProps } from './types';
import _ from 'lodash';
import { InsureRuleCount } from 'constants/enums/showCount.enum';

const CarInsureRules: React.FC<IProps> = (props) => {
  /**
   * @description 建立左側標頭 (手機版)
  */
  const handleCreateTitleMobile = (lmtContent:any) => {
    const titles = new Array(0);
    _.forEach(lmtContent, (content:string[], index:number) => {
      if (!content[0] && index < 3) return;

      titles.push(content[0]);
    });

    return _.map(titles, (str:string, index:number) => (
      <div className={str !== '' ? 'element__table-grid-y-title' : 'element__table-grid-y-divider'} key={index}>
        {str}
      </div>
    ));
  };

  /**
   * @description 建立車險上方顯示標頭
  */
  const handleCreateCarLmtHeader = () => {
    const carLmtCpy = [...props.carLmt];
    const carLmtVal = carLmtCpy.splice(0, 3);
    const headerTop:any[] = _.filter(carLmtVal[0], (str:string) => str);
    const headerMedium:any[] = _.filter(carLmtVal[1], (str:string) => str);
    const headerBottom:any[] = _.filter(carLmtVal[2], (str:string) => str);
    return (
      <>
        <tr className="element__table-grid-main-title-tr">
          <th />
          {
            _.map(headerTop, (content:string, index:number) => {
              if (!content) return;

              if (index === 0) return <th key={index} colSpan={4}>{content}</th>;

              if (index === headerTop.length - 1) return <th key={index}>{content}</th>;

              return <th key={index} colSpan={2}>{content}</th>;
            })
          }
        </tr>
        <tr className="element__table-grid-x-title-tr">
          {
            _.map(headerMedium, (content:string, index:number) => {
              if (index === 1 || index === 2) return <th key={index} colSpan={2}>{content}</th>;

              return <th key={index} rowSpan={2}>{content}</th>;
            })
          }
        </tr>
        <tr className="element__table-grid-x-title-tr">
          {
            _.map(headerBottom, (content:string, index:number) => {
              return <th key={index}>{content}</th>;
            })
          }
        </tr>
      </>
    );
  };

  /**
   * @description 建立欄位內容集合
   * @param startIndex 迴圈起始 index
   * @param 顯示欄位數
  */
  const handleCreateTbody = (carLmt:string[][], startIndex:number, defaultCount:number) => {
    const tbody = new Array(0);

    for (let i = startIndex; i < carLmt.length; i += 1) {
      const child = handleCreateLmtBody(carLmt[i], defaultCount, i);
      tbody.push(child);
    }

    return tbody;
  };

  /**
   * @description 建立欄位內容
  */
  const handleCreateLmtBody = (content:string[], defaultCount:number, index:number) => {
    if (content.length === 0) return;

    const childs = new Array(0);
    childs.push(<th key={0} className="element__table-grid-y-title">{content[0]}</th>);
    for (let i = 1; i <= defaultCount; i += 1) {
      let child = <td key={i} />;
      if (content[i] && content[i].toUpperCase() === 'V') {
        child = (
          <td key={i}>
            <i className="element__tick-icon" />
          </td>
        );
      }
      childs.push(child);
    }

    const tableTr = content.length > 1 ? (
      <tr key={index}>{childs}</tr>
    ) : (
      <tr key={index} className="element__table-grid-x-divider">{childs}</tr>
    );

    return tableTr;
  };

  /**
   * @description 建立車體險標頭
  */
  const hanldeCreateCarBodyTitle = (content:string[]) => {
    const childs = _.map(content, (str:string, index:number) => {
      return <th key={index}>{str}</th>;
    });

    return (
      <tr className="element__table-grid-main-title-tr">
        {childs}
      </tr>
    );
  };

  return props.carLmt && props.carLmt[0] && props.carLmt[0].length > 0 ? (
    <div className="car-insure-rules">
      <div className="car-insure-rules__prod-limit-table">
        <div className="car-insure-rules__prod-limit-table-title">承保範圍</div>
        <div className="element__table-grid">
          <div className="element__table-grid-y-fixed">
            {handleCreateTitleMobile(props.carLmt)}
          </div>
          <div className="element__table-grid-wrap">
            <div className="element__table-grid-container">
              <table>
                <tbody>
                  {handleCreateCarLmtHeader()}
                  {handleCreateTbody(props.carLmt, 3, InsureRuleCount.Default)}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {
        props.carBodyLmt && props.carBodyLmt[0] && props.carBodyLmt[0].length > 0 ? (
          <div className="car-insure-rules__coverage-table">
            <div className="car-insure-rules__coverage-table-title">車體險承保範圍</div>
            <div className="element__table-grid">
              <div className="element__table-grid-y-fixed">
                {handleCreateTitleMobile(props.carBodyLmt)}
              </div>
              <div className="element__table-grid-wrap">
                <div className="element__table-grid-container">
                  <table>
                    <tbody>
                      {hanldeCreateCarBodyTitle(props.carBodyLmt[0])}
                      {handleCreateTbody(props.carBodyLmt, 1, InsureRuleCount.CarBody)}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        ) : null
      }
    </div>
  ) : null;
};

export default CarInsureRules;
